//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveAs } from "file-saver";
export default {
  components: {
    saveAs,
  },
  data() {
    return {
      fileSize: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fileSize = this.calFileSize(this.data.audio_file);
    });
  },
  methods: {
    downloadAudio(audio) {
      let filename = audio.split("/").pop();
      saveAs(audio, filename);
    },
    showModal() {
      this.$emit("click", { index: this.index, fileSize: this.fileSize });
    },
    calFileSize(url) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer";
      xhr.onreadystatechange = (e) => {
        if (e.target.readyState == e.target.DONE) {
          this.fileSize = e.target.response.byteLength;
        }
      };
      xhr.send(null);
    },
  },
  props: {
    data: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
    },
  },
};
